import { forwardRef, memo, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import "./UI/AnimalSorat.scss"

import jogoDoBichoTitle from "../../../../../assets/games/AnimalSorat/Title.png"
import backgroundImg from "../../../../../assets/games/AnimalSorat/Jogo-Do-Bicho-3-2.png"
import blinkImg from "../../../../../assets/games/AnimalSorat/Box/blink.png"

import winBalBack from "../../../../../assets/games/AnimalSorat/Win.png"
import buttonBack from "../../../../../assets/games/AnimalSorat/Button.png"
import help_btn from "../../../../../assets/games/AnimalSorat/help_btn.webp"
import sound_back from "../../../../../assets/games/AnimalSorat/sound.webp"
import snd_on from "../../../../../assets/games/AnimalSorat/Jogo-Do-Bicho_Volume_1.svg"
import snd_off from "../../../../../assets/games/AnimalSorat/Jogo-Do-Bicho_No-volume_1.svg"
import music_off from "../../../../../assets/games/AnimalSorat/Jogo-Do-Bicho_No-music_1.svg"
import music_on from "../../../../../assets/games/AnimalSorat/Jogo-Do-Bicho_Music_1.svg"

import AnimalSoratGameBoard from "./UI/AnimalSoratGameBoard";
import AnimalSoratButtonsController from "./UI/AnimalSoratButtonsController";
import { changeAmountToFixed } from "../../../Utillitys/changeAmountToFixed";
import { gsap } from "gsap";
import { Howl, Howler } from "howler"

import betChipSnd from "../../../../../assets/sounds/betoncard.mp3"
import msgSnd from "../../../../../assets/sounds/coindrop_old.mp3"
import clearSnd from "../../../../../assets/sounds/clear.mp3"
import loseSnd from "../../../../../assets/sounds/duplose.mp3"
import pokerChipSnd from "../../../../../assets/sounds/pokerChip.mp3"
import buttonClickSnd from "../../../../../assets/sounds/buttonClick.mp3"
import glowSnd from "../../../../../assets/sounds/successNew.mp3"
import invalidBetSnd from "../../../../../assets/sounds/alert.mp3"
import woodBrkSnd from "../../../../../assets/sounds/wood_break2.ogg"
import winMusicSnd from "../../../../../assets/sounds/winMusic.ogg"
import AnimalRevealSnd from "../../../../../assets/sounds/AnimalRevealSound.ogg"
import boxKnockSnd from "../../../../../assets/sounds/door-knocking.ogg"
import swingSnd from "../../../../../assets/sounds/sling-swing2.ogg"
import JGB_Theme_music from "../../../../../assets/sounds/JoGoDoBicho_Theme_1.ogg"
import popUp_sound from "../../../../../assets/sounds/popUp_1.ogg"
import AnimalSoratGameOptions from "./UI/AnimalSoratGameOptions";
import useSafeTimeout from "../../../Utillitys/useSafeTimeout";


const AnimalSorat = forwardRef((props, ref) => {

    const [selectedChip, setSelectedChip] = useState({ value: props.as_chipValues?.split(",")[0], index: 0 })
    const [betObject, setBetObject] = useState({})
    const [splitBetObject, setSplitBetObject] = useState({})
    const [betAmount, setBetAmount] = useState(0)
    const [duplicateBetAmount, setDuplicateBetAmount] = useState(0)
    const [isBetFreezed, setIsBetFreezed] = useState(false)
    const [winAmount, setWinAmount] = useState(0)
    const [showWinAmount, setShowWinAmount] = useState(false)
    const [winningAnimal, setWinningAnimal] = useState(null)
    const [winningNumber, setWinningNumber] = useState(null)
    const [enterPopUp, setEnterPopUp] = useState(true);
    const [showGameRules, setShowGameRules] = useState(false);
    const [isThemeMuted, setIsThemeMute] = useState(false);
    const [isSoundsMute, setIsSoundsMute] = useState(false);
    const [isDoubleDisabled, setDoubleDisabled] = useState(false);
    const [infoText, setInfoText] = useState(props.language.JDB_BetMsg);
    const [betBtn, setBetBtn] = useState(props.gameState.betRequest?.betString ? props.language.Prev : props.language.BetOK)

    const isInitial = useRef(true)
    const animalSoratBoardRef = useRef()
    const animalSoratBtnRef = useRef()
    const playingSound = useRef()
    const soundLoopTimeout = useRef()
    const soundsRef = useRef({});
    const betRequestTimeOut = useRef(null);
    const themeMusicRef = useRef(null);
    const isThemePlaying = useRef(false);
    const { setSafeTimeout } = useSafeTimeout();

    useEffect(() => {
        if (showWinAmount) {
            playTheSound("winMusic")
            startBlinkingEffects()

            // Auto close after 3 seconds
            const timer = setTimeout(() => {
                stopBlinkingEffects()
                setShowWinAmount(false)
                setInfoText(props.language.Click_BetOk)
            }, 3000);

            return () => clearTimeout(timer);
        } else {
            setSafeTimeout(() => {
                setWinAmount(0)
            }, 500)
            if (!isInitial.current) {
                setInfoText(props.language.Click_BetOk)
            }
        }
    }, [showWinAmount]);

    useEffect(() => {
        if (!soundsRef.current?.cardFallSound) {
            soundsRef.current = {
                betChipSound: new Howl({ src: [betChipSnd], html5: true }),
                messageSound: new Howl({ src: [msgSnd], html5: true }),
                clearSound: new Howl({ src: [clearSnd], html5: true }),
                lostSound: new Howl({ src: [loseSnd], html5: true }),
                pokerChipSound: new Howl({ src: [pokerChipSnd], html5: true }),
                winGlowSound: new Howl({ src: [glowSnd], html5: true }),
                invalidBet: new Howl({ src: [invalidBetSnd], html5: true }),
                woodBreak: new Howl({ src: [woodBrkSnd], html5: true }),
                winMusic: new Howl({ src: [winMusicSnd], html5: true }),
                AnimalReveal: new Howl({ src: [AnimalRevealSnd], html5: true }),
                buttonClick: new Howl({ src: [buttonClickSnd], html5: true }),
                swingSound: new Howl({ src: [swingSnd], html5: true }),
                boxKnock: new Howl({ src: [boxKnockSnd], html5: true }),
                JGB_gameRules_sound: new Howl({ src: [popUp_sound], html5: true }),
            };

            themeMusicRef.current = new Howl({
                src: [JGB_Theme_music],
                html5: true,
                loop: true,
                volume: 1
            });
        }

        const resumeAudio = () => {
            const ctx = Howler.ctx;
            if (!ctx) return;
            // alert(ctx.state)

            if (ctx.state === "interrupted" || ctx.state === "suspended") {
                ctx.resume().then(() => {
                    themeMusicRef.current.stop();
                    themeMusicRef.current.play();
                });
            }
        };

        const suspendAudio = () => {
            const ctx = Howler.ctx;
            if (!ctx) return;
            // alert(ctx.state)
            if (ctx.state === "running") {
                ctx.suspend().then(() => {
                    themeMusicRef.current.stop();
                });
            } else if (ctx.state === "interrupted") {
                themeMusicRef.current.stop();
                return
            }
        };

        const onVisibilityChange = () => {
            // alert(document.hidden)
            if (document.hidden) suspendAudio();
            else resumeAudio();
        };

        // Android + Desktop
        window.addEventListener("visibilitychange", onVisibilityChange);

        // iOS Safari (fires when app goes to background or phone locks)
        window.addEventListener("pagehide", suspendAudio);
        window.addEventListener("pageshow", resumeAudio);

        props.assestsLoaderFunction();
        isInitial.current = false;

        return () => {
            window.removeEventListener("visibilitychange", onVisibilityChange);
            window.removeEventListener("pagehide", suspendAudio);
            window.removeEventListener("pageshow", resumeAudio);
            clearTimeout(soundLoopTimeout.current)
        };
    }, []);

    useEffect(() => {
        if (checkDisableBetBtn()) {
            setDoubleDisabled(true)
        } else {
            setDoubleDisabled(false)
        }
    }, [betAmount])

    const playThemeMusic = () => {
        if (props.isIphone) {
            return
        }
        if (themeMusicRef.current && !isThemePlaying.current) {
            themeMusicRef.current.play();
            isThemePlaying.current = true;
        }
    };

    const stopThemeMusic = () => {
        if (themeMusicRef.current && isThemePlaying.current) {
            themeMusicRef.current.stop();
            isThemePlaying.current = false;
        }
    };



    useEffect(() => {
        if (winningAnimal !== null) {
            animalSoratBoardRef?.current?.triggerReveal()
        }
    }, [winningAnimal])

    useEffect(() => {
        if (soundsRef.current) {
            Object.values(soundsRef.current).forEach(sound => {
                if (sound && typeof sound.mute === "function") {
                    sound.mute(isSoundsMute);
                }
            });
        }
    }, [isSoundsMute])

    useEffect(() => {
        if (themeMusicRef.current) {
            themeMusicRef.current.mute(isThemeMuted)
        }
    }, [isThemeMuted])

    const backgroundStyle = useMemo(() => ({
        mainBackgroundImage: { backgroundImage: `url(${backgroundImg})` },
        winBalBack: { backgroundImage: `url(${winBalBack})` },
        titleImage: jogoDoBichoTitle,
        betBtnBack: { backgroundImage: `url(${buttonBack})` },
    }), []);

    const playTheSound = (sound, isLoopd = false, delay = 0) => {
        if (isSoundsMute) {
            return
        }
        // Stop currently playing sound (unless you want overlapping sounds)
        if (playingSound.current) {
            playingSound.current.stop();
            clearTimeout(soundLoopTimeout.current)
            soundLoopTimeout.current = null
        }

        // Choose new sound
        const soundObj = soundsRef.current[sound];
        playingSound.current = soundObj;

        if (!playingSound.current) return;
        if (isLoopd) {
            // Enable / Disable looping
            playingSound.current.loop(isLoopd);
            soundLoopTimeout.current = setTimeout(() => {
                playingSound.current.play();
            }, delay)
        } else {
            // Play sound
            playingSound.current.play();
        }
    };

    useImperativeHandle(ref, () => ({
        updateGameState,
        checkAnimalSoratResult,
        updateMessage,
        updateHistory: (res) => { },
        updatePlayerInfo: () => { setDuplicateBetAmount(0) }
    }))


    const updateGameState = () => {
        if (props.gameState.handId !== props.gameState.oldHandId && !isInitial.current) {
            let winAnimal = props.animalSoratResult.resultNum || 100
            winAnimal = Math.ceil(winAnimal / 4) - 1
            // animalSoratBoardRef?.current?.animateResultToHistory(winAnimal)
            animalSoratBoardRef?.current?.updateHistory([...props.gameState.history])
            // setInfoText(props.language.JDB_BetMsg)
            animalSoratBoardRef?.current?.closeAnimation()
        }
    }

    const checkAnimalSoratResult = (res) => {
        clearTimeout(betRequestTimeOut.current);
        betRequestTimeOut.current = null;
        let winAnimal = res.resultNum || 100
        winAnimal = Math.ceil(winAnimal / 4) - 1
        setInfoText(`${props.language.Bet_Accepted} ${res.betAmount}`)
        setSafeTimeout(() => {
            setWinAmount(res.winAmount)
            setWinningAnimal(winAnimal)
            setWinningNumber(res.resultNum)
        }, 2000)
    }

    const betPlacedOn = (type, idx) => {
        let betObj = { ...betObject }
        let splitBetObj = { ...splitBetObject }
        let chipValue = Number(selectedChip.value)
        let newBetAmount = Number(betAmount + chipValue)
        let updatedBalance = Number(props.balance - newBetAmount)
        let [[numberMinBet, numberMaxBet], [animalMinBet, animalMaxBet]] = props.as_innerLimits.split("|").map(ele => ele.split("-"))
        if (!chipValue || updatedBalance < 0 || (newBetAmount < props.minBetAmt) || (newBetAmount > props.maxBetAmt) || isBetFreezed) {
            if (newBetAmount < props.minBetAmt || newBetAmount > props.maxBetAmt) {
                setInfoText(`${props.language.MinBetAmt} ${props.minBetAmt} \n ${props.language.MaxBetAmt} ${props.maxBetAmt}`)
            } else if (updatedBalance < 0) {
                setInfoText(`${props.language.Low_Balance}`)
            } else if (type === "animal" && (newBetAmount < animalMinBet || newBetAmount > animalMaxBet)) {
                setInfoText(`${props.language.AnimalMinLimit} ${animalMinBet} \n ${props.language.AnimalMaxLimit} ${props.animalMaxBet}`)
            } else if (type === "numbers" && (newBetAmount < numberMinBet || newBetAmount > numberMaxBet)) {
                setInfoText(`${props.language.NumbersMinLimit} ${numberMinBet} \n ${props.language.NumbersMaxLimit} ${numberMaxBet}`)
            }
            playTheSound("invalidBet")
            return
        }
        switch (type) {
            case "animal": betObj[idx] = changeAmountToFixed((betObj[idx] ?? 0) + chipValue, 2);
                setBetObject({ ...betObj })
                break;
            case "numbers": splitBetObj[idx] = changeAmountToFixed((splitBetObj[idx] ?? 0) + chipValue, 2);
                setSplitBetObject({ ...splitBetObj })
                break;
            default: break;
        }
        playTheSound("betChipSound")
        setBetAmount(changeAmountToFixed(newBetAmount, 2))
        setDuplicateBetAmount(changeAmountToFixed(newBetAmount, 2))
        setInfoText(props.language.Click_BetOk)
        if (betBtn === props.language.Prev) {
            setBetBtn(props.language.BetOK)
        }
    }

    const buttonClicked = (type) => {
        switch (type) {
            case props.language.Clear: clearAllBets(); break;
            case props.language.BetOK: sendBetRequest(); break;
            case props.language.Double: doubleAllBets(); break;
            case props.language.Prev: setPreviousBetRequest(); break;
            case props.language.TAKE: sendTakeAction(); break;
            default: break;
        }
    }

    const clearAllBets = () => {
        if (!betAmount || isBetFreezed) {
            return
        }
        playTheSound("clearSound")
        setBetObject({})
        setSplitBetObject({})
        setBetAmount(0)
        setDuplicateBetAmount(0)
        setInfoText(props.language.JDB_BetMsg)
        if (props.gameState.betRequest?.betString) {
            setBetBtn(props.language.Prev)
        } else {
            setBetBtn(props.language.BetOK)
        }
    }

    const doubleAllBets = () => {
        if (!betAmount || isBetFreezed) return false;

        const [[numberMinBet, numberMaxBet], [animalMinBet, animalMaxBet]] =
            props.as_innerLimits
                .split("|")
                .map(ele => ele.split("-").map(Number));

        const animalBets = { ...betObject };
        const numberBets = { ...splitBetObject };

        let total = betAmount;
        let didDouble = false;

        const newAnimalBets = { ...animalBets };
        const newNumberBets = { ...numberBets };

        // 🔹 Double animals per-item
        for (const key in animalBets) {
            const current = animalBets[key];
            if (!current) continue;

            const doubled = current * 2;

            if (doubled <= animalMaxBet && total + current <= props.maxBetAmt && total + current <= props.balance) {
                newAnimalBets[key] = doubled;
                total += current;
                didDouble = true;
            }
        }

        // 🔹 Double numbers per-item
        for (const key in numberBets) {
            const current = numberBets[key];
            if (!current) continue;

            const doubled = current * 2;

            if (doubled <= numberMaxBet && total + current <= props.maxBetAmt && total + current <= props.balance) {
                newNumberBets[key] = doubled;
                total += current;
                didDouble = true;
            }
        }

        if (!didDouble) {
            playTheSound("invalidBet");
            setInfoText(props.language.MaxInrBetAmt + props.maxBetAmt);
            return false;
        }

        playTheSound("buttonClick");

        setBetObject(newAnimalBets);
        setSplitBetObject(newNumberBets);
        setBetAmount(changeAmountToFixed(total, 2));
        setDuplicateBetAmount(changeAmountToFixed(total, 2));
    };



    const sendBetRequest = () => {
        if (betAmount > props.balance || betAmount < props.minBetAmt || betAmount > props.maxBetAmt) {
            return
        }

        let body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "ANIMAL_SORAT_BET",
            "object": {
                "gameId": props.gameId,
                "playerId": props.playerId,
                "betAmount": Number(betAmount),
                "action": "ANIMAL_SORAT_BET",
                "handId": Number(props.gameState.handId),
                "betString": Array(25).fill(0).map((_, idx) => betObject[idx] ?? 0).join("|") + "," + Array(100).fill(0).map((_, idx) => splitBetObject[idx] ?? 0).join("|"),
            },
        }
        playTheSound("buttonClick")
        betRequestTimeOut.current = setTimeout(() => {
            if (betRequestTimeOut.current) {
                props.showTimeOut("Re-Connecting......!\n Please Click on Refresh");
                betRequestTimeOut.current = null;
            }
        }, 5000);
        setInfoText(props.language.Bet_Processing_Msg)
        setIsBetFreezed(true)
        animalSoratBoardRef?.current?.firstAnimation()
        props.network?.sendof(body)
    }

    const updateMessage = () => {
        setInfoText(props.infoText)
    };

    const sendTakeAction = () => {

    }

    const setPreviousBetRequest = () => {
        if (props.gameState.betRequest.betAmount > props.balance) {
            setInfoText(`${props.language.Low_Balance}`)
            playTheSound("invalidBet")
            return
        }
        if (props.gameState.handId !== props.gameState.oldHandId && props.gameState.betRequest) {
            let betRequest = props.gameState.betRequest.betString.split(",")
            let betObj = Object.fromEntries(
                betRequest[0]
                    .split("|")
                    .map((val, idx) => [idx, Number(val)])
                    .filter(([_, val]) => val !== 0)
            );
            let splitObj = Object.fromEntries(
                betRequest[1]
                    .split("|")
                    .map((val, idx) => [idx, Number(val)])
                    .filter(([_, val]) => val !== 0)
            );
            playTheSound("buttonClick")
            setBetObject({ ...betObj })
            setSplitBetObject({ ...splitObj })
            setBetAmount(props.gameState.betRequest.betAmount)
            setDuplicateBetAmount(props.gameState.betRequest.betAmount)
            setBetBtn(props.language.BetOK)
        }
    }

    const onAnimationCompleted = () => {
        if (winAmount) {
            setShowWinAmount(true)
            setInfoText(`${props.language.You_won} ${winAmount}`)
        }
        setWinningAnimal(null);
        setWinningNumber(null);
        setIsBetFreezed(false);
        if (props.gameState?.betRequest?.betAmount > (Number(props.balance) + Number(props.animalSoratResult.winAmount))) {
            setInfoText(`${props.language.Low_Balance}`)
            setBetObject({})
            setSplitBetObject({})
            setBetAmount(0)
            setDuplicateBetAmount(0)
        } else if(!winAmount){
            setInfoText(props.language.JDB_BetMsg)
        }
    }

    const getGameStatePlayerBalance = () => {
        props.gamstateHandle()
        props.playerBalanceHandle()
    }


    let blinkingActive = useRef(false);  // Prevent duplicate runs
    let blinkStopFn = useRef(null);      // Store cleanup for later

    function startBlinkingEffects() {
        // Prevent duplicate activation
        if (blinkingActive.current) return;
        blinkingActive.current = true;

        const baseImg = document.querySelector("#blinkImage");
        const blinkContainer = document.querySelector("#winAnimateBox");
        if (!baseImg || !blinkContainer) return;

        // Predefined gentle spiral offsets (px from center)
        const patternOffsets = [
            { x: 0, y: 0 },
            { x: 100, y: 0 },
            { x: -20, y: 120 },
            { x: 100, y: 200 },
            { x: 120, y: -160 },
            { x: 500, y: 200 },
            { x: 350, y: 100 },
            { x: -250, y: -50 },
            { x: -100, y: 100 },
            { x: -50, y: 300 },
        ];

        let patternIndex = 0;
        let stopped = false; // used for graceful cleanup

        function createBlink() {
            const rect = blinkContainer.getBoundingClientRect();
            if (rect.width <= 0 || rect.height <= 0) return;

            const centerX = rect.width / 2;
            const centerY = rect.height / 2;

            // pick offset from pattern (looping)
            const offset = patternOffsets[patternIndex % patternOffsets.length];
            patternIndex++;

            const x = centerX + offset.x;
            const y = centerY + offset.y;

            const clone = baseImg.cloneNode(true);
            Object.assign(clone.style, {
                display: "block",
                position: "absolute",
                transformOrigin: "center",
                pointerEvents: "none",
                opacity: "0.8",
                filter: "drop-shadow(0 0 20px rgba(255,255,180,0.9))",
            });
            blinkContainer.appendChild(clone);

            gsap.set(clone, { left: x, top: y, scale: 0, opacity: 0 });

            gsap.timeline({
                onComplete: () => clone.remove(),
            })
                .to(clone, {
                    scale: gsap.utils.random(0.8, 1.3),
                    opacity: 1,
                    duration: 0.4,
                    ease: "power2.out",
                })
                .to(clone, {
                    scale: "+=0.1",
                    duration: 0.25,
                    ease: "sine.inOut",
                })
                .to(clone, {
                    scale: 0,
                    opacity: 0,
                    duration: 0.6,
                    ease: "power2.inOut",
                });
        }

        function loopBlink() {
            if (stopped) return;
            createBlink();
            const nextDelay = gsap.utils.random(0.5, 1.0, true);
            gsap.delayedCall(nextDelay, loopBlink);
        }

        loopBlink();

        // Cleanup function
        blinkStopFn.current = () => {
            stopped = true;
            blinkingActive.current = false;
            gsap.globalTimeline.clear(); // kill any delayed calls
            const allClones = blinkContainer.querySelectorAll("#blinkImage:not(:first-child)");
            allClones.forEach((el) => el.remove());
        };
    }

    // Optional: stop animation manually if needed
    function stopBlinkingEffects() {
        if (blinkStopFn.current) blinkStopFn.current();
    }

    const checkDisableBetBtn = () => {
        const animalBets = Object.values(betObject);
        const numberBets = Object.values(splitBetObject);

        const [[numberMin, numberMax], [animalMin, animalMax]] =
            props.as_innerLimits
                .split("|")
                .map(ele => ele.split("-").map(Number));

        const totalCurrent = animalBets.reduce((a, b) => a + b, 0) +
            numberBets.reduce((a, b) => a + b, 0);

        const remainingTotal = props.maxBetAmt - totalCurrent;

        // Check if **any animal** can double
        const canDoubleAnimal = animalBets.some(bet => {
            if (!bet) return false;
            const doubled = bet * 2;
            return doubled <= animalMax && doubled - bet <= remainingTotal;
        });

        // Check if **any number** can double
        const canDoubleNumber = numberBets.some(bet => {
            if (!bet) return false;
            const doubled = bet * 2;
            return doubled <= numberMax && doubled - bet <= remainingTotal;
        });

        return !(canDoubleAnimal || canDoubleNumber);
    };



    return <div id="AnimalSoratGame" className="AnimalSoratGame" style={backgroundStyle.mainBackgroundImage}>
        <img src={help_btn} id="AS_help_button" onClick={() => { setShowGameRules(true); playTheSound("JGB_gameRules_sound") }} alt="" draggable={false} />
        <div className="AS_sound_music_controllers AS_sound_ctrl">
            <img src={isSoundsMute ? snd_off : snd_on} id="AS_sound_button" onClick={() => { setIsSoundsMute(prev => !prev) }} alt="" draggable={false} />
        </div>
        {!props.isIphone && <div className="AS_sound_music_controllers AS_music_ctrl">
            <img src={isThemeMuted ? music_off : music_on} id="AS_music_button" onClick={() => { setIsThemeMute(prev => !prev) }} alt="" draggable={false} />
        </div>}

        <div id="userDetails">
            <div id="balanceDiv">
                <div>BALANCE</div>
                <div className="winBalBack" style={backgroundStyle.winBalBack}>{changeAmountToFixed(props.balance - duplicateBetAmount, 2)}</div>
            </div>
            <div id="titleDiv">
                <img src={backgroundStyle.titleImage} className="titleImage" alt="" />
            </div>
            <div id="winDiv">
                <div>WIN</div>
                <div className="winBalBack" style={backgroundStyle.winBalBack}>{winAmount}</div>
            </div>
        </div>

        <AnimalSoratGameBoard
            ref={animalSoratBoardRef}
            as_chipValues={props.as_chipValues}
            betPlacedOn={betPlacedOn}
            selectedChip={selectedChip}
            betObject={betObject}
            splitBetObject={splitBetObject}
            handId={props.gameId}
            gameState={props.gameState}
            winningAnimal={winningAnimal}
            winningNumber={winningNumber}
            onAnimationCompleted={onAnimationCompleted}
            getGameStatePlayerBalance={getGameStatePlayerBalance}
            isBetFreezed={isBetFreezed}
            language={props.language}
            playTheSound={playTheSound}
            isInitial={isInitial.current}
            setDupBetAmt={() => setDuplicateBetAmount(betAmount > props.balance ? 0 : betAmount)}
            setSelectedChip={setSelectedChip}>
        </AnimalSoratGameBoard>
        <AnimalSoratButtonsController
            ref={animalSoratBtnRef}
            buttonClicked={buttonClicked}
            betBtn={betBtn}
            betAmount={betAmount}
            playTheSound={playTheSound}
            language={props.language}
            isDoubleDisabled={isDoubleDisabled}
            isBetFreezed={isBetFreezed}
        ></AnimalSoratButtonsController>
        <div id="playerDetails">
            <div>P ID : {props.playerId}</div>
            <div>Hand ID : {props.gameState?.handId}</div>
        </div>
        <div id="playerName">{props.user}</div>
        <div id="totalBetAmount">
            <div>TOTAL BET</div>
            <div className="winBalBack" style={backgroundStyle.winBalBack}>{changeAmountToFixed(betAmount, 2)}</div>
        </div>
        <div id="infoTextBox">
            <p className="infoTxt">{infoText}</p>
        </div>
        <div className={`winAnimationBack ${showWinAmount ? "showBackdrop" : ""}`}>
            <div
                id="winAnimateBox"
                className={`winAnimate ${showWinAmount ? "showWinPopUp" : ""}`}
            >
                <img id="blinkImage" src={blinkImg} alt="blink" style={{ display: "none" }} />
                <div className="totalWinDiv">TOTAL WIN</div>
                <div className="totalWinAmt">{winAmount}</div>
            </div>
        </div>
        {enterPopUp && <div className="iosFetchSounds" id="iospopup" onClick={(e) => { playThemeMusic(); setEnterPopUp(false) }}>
            <div className="popupTooLong">
                <div className="mt-2">{props.language.Wel_JDB}</div>
                {props.language?.OK_Btn}
                <br></br>
                <br></br>
                <div className="fd">
                    <button className="btn_iosPopup"> OK </button>
                    <br></br>
                </div>
            </div>
        </div>}
        {showGameRules && <AnimalSoratGameOptions
            as_innerLimits={props.as_innerLimits}
            minBetAmt={props.minBetAmt}
            game_PayoutInfo={props.game_PayoutInfo}
            maxBetAmt={props.maxBetAmt}
            closeGameRules={() => { setShowGameRules(false); playTheSound("JGB_gameRules_sound") }}
        ></AnimalSoratGameOptions>}
    </div>
})


export default memo(AnimalSorat)